import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { requestIntro } from '../../api'

export default class Vendor extends Component {
	state = {
		requested: false,
		requesting: false
	}

	renderLogo() {
		let { name, logo } = this.props.vendor
		if(logo) {
			return (
				<img className="partner-logo" src={logo} alt={name} />
			)
		} else {
			return (
				<h3>{name}</h3>
			)
		}
	}

	renderPlatforms(platforms) {
		const icons = {
			'Facebook': 'https://www.datocms-assets.com/3323/1538420819-facebook-icon.png',
			'Twitter': 'https://www.datocms-assets.com/3323/1538420828-twitter-icon.png',
			'Instagram': 'https://www.datocms-assets.com/3323/1538420822-ig-icon.png',
			'Snapchat': 'https://www.datocms-assets.com/3323/1538420826-snapchat-icon.png',
			'Pinterest': 'https://www.datocms-assets.com/3323/1538420824-pinterest-icon.png',
			'YouTube': 'https://www.datocms-assets.com/3323/1538420830-youtube-icon.png'
		}
		return platforms.map((platform, idx) => {
			return (<li key={idx}><img className="platform-icon" src={icons[platform]} alt={`${platform} Logo`} /></li>)
		})
	}

	requestVendorIntro = async () => {
		if(this.state.requested || this.state.requesting) { return true }
		this.setState({requesting: true})
		const res = await requestIntro(this.props.resultsId, this.props.vendor.vendor_id)
		if(res) {
			this.setState({requested: true})
		} else {
			this.setState({requested: false, requesting: false})
		}
	}

	render() {
		let { description, additional_capabilities, matched_capabilities, platforms, video, video_thumb, name } = this.props.vendor
		return (
			<div className="row partner-card">
				<div className="two-thirds column main-info">
					{this.renderLogo()}
					<p className="company-desc">{description}</p>
					<div className="row">
						<div className="one-half column capabilities-block">
							<h4>Matched Capabilities</h4>
							<ul>
								{matched_capabilities.map((capability, idx) => {
									return (<li key={idx}>{capability}</li>)
								})}
							</ul>
						</div>
						<div className="one-half column capabilities-block">
							<h4>Additional Capabilities</h4>
							<ul>
								{additional_capabilities.map((capability, idx) => {
									return (<li key={idx}>{capability}</li>)
								})}
							</ul>
						</div>
					</div>
				</div>
				<div className="one-third column cta-section">
					<a className="mediabox" href={video}><img src={video_thumb} alt={`${name} Video`} /></a>
					<button className={this.state.requested ? 'requested' : ''} onClick={this.requestVendorIntro}>
						{this.state.requested ? 'Requested' : 'Connect'}
					</button>
					<div className="platform-support">
						<h4>Platform Support</h4>
						<ul>
							{this.renderPlatforms(platforms)}
						</ul>
					</div>
				</div>
			</div>
		)
	}
}

Vendor.propTypes = {
	vendor: PropTypes.object,
	resultsId: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/containers/Results/Vendor.js